import { MainScreen } from '@components/shared/MainScreen/MainScreen';
import { useState } from 'react';
import { useAuthStore } from '@stores/authStore';
import {
  PreferencesSection,
  SecuritySection,
  UnsavedChangesBar,
} from './components';

export default function SettingsPage() {
  const { preferences, setPreferences, session } = useAuthStore();
  const [draft, setDraft] = useState(preferences);
  const hasChanges =
    draft.language !== preferences.language ||
    draft.timezone !== preferences.timezone;
  return (
    <MainScreen headerContent={<h1>Settings</h1>}>
      <div className="relative mx-auto w-full max-w-[800px] pb-32 text-start">
        <PreferencesSection
          data={draft}
          onChange={(field, value) =>
            setDraft((previous) => ({ ...previous, [field]: value }))
          }
        />
        <SecuritySection key={session?.principalId} />
        {hasChanges && (
          <UnsavedChangesBar
            onDiscard={() => setDraft(preferences)}
            onSave={() => setPreferences(draft)}
          />
        )}
      </div>
    </MainScreen>
  );
}
